import React from 'react';
import {
  InvoiceSigningPreviewApprovalMap,
  InvoiceSigningPreviewApprovalMap_invoiceSigningPreviewApprovalMap_nodes,
  InvoiceSigningPreviewApprovalMapVariables,
} from './__generated__/invoiceSigningPreviewApprovalMap';

import { NodeView } from './NodeView';

import { GenericHierarchyFlow } from 'common/components/PreviewApprovalHierarchyReactFlow';

import ENTITY_APPROVAL_MAP from './invoiceSigningPreviewApprovalMap.graphql';

export interface HierarchyNode
  extends InvoiceSigningPreviewApprovalMap_invoiceSigningPreviewApprovalMap_nodes {
  children?: HierarchyNode[];

  width?: number;
  height?: number;
}

interface HierarchyProps {
  entityId: string;
}

export const Hierarchy: React.FC<HierarchyProps> = ({ entityId }) => {
  // Function to extract nodes from the query data
  const getNodesFromData = (data: InvoiceSigningPreviewApprovalMap) => {
    return data?.invoiceSigningPreviewApprovalMap?.nodes?.map((node) => ({
      ...node,
      level: node.level ?? 0,
      width: 300,
      height: 200,
      children: [], // Ensure children is included
    }));
  };

  return (
    <GenericHierarchyFlow<
      InvoiceSigningPreviewApprovalMap,
      InvoiceSigningPreviewApprovalMapVariables
    >
      entityId={entityId}
      query={ENTITY_APPROVAL_MAP}
      queryVariables={{ entityId }}
      getNodesFromData={getNodesFromData}
      NodeViewComponent={(props) => (
        <NodeView
          data={props.data as unknown as HierarchyNode}
          key={props.data.id}
        />
      )}
    />
  );
};
